import { render, staticRenderFns } from "./formatedRow.vue?vue&type=template&id=16600e94"
import script from "./formatedRow.vue?vue&type=script&lang=js"
export * from "./formatedRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports